import { CommonModule, formatDate } from '@angular/common';
import { Injectable, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from '@components/button/button.module';
import { IconModule } from '@components/icon/icon.module';
import {
  CalendarAngularDateFormatter,
  CalendarDateFormatter,
  CalendarModule as AngularCalendarModule,
  DateAdapter,
  DateFormatterParams,
} from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { CalendarComponent } from './calendar.component';

@Injectable()
class NumericTimeFormatter extends CalendarAngularDateFormatter {
  override monthViewColumnHeader({ date, locale }: DateFormatterParams): string {
    return formatDate(date, 'EEEEEE', locale);
  }

  override weekViewColumnHeader({ date, locale }: DateFormatterParams): string {
    return formatDate(date, 'EEEEEE', locale);
  }

  override weekViewColumnSubHeader({ date, locale }: DateFormatterParams): string {
    return formatDate(date, 'd', locale);
  }

  override weekViewHour({ date, locale }: DateFormatterParams): string {
    return formatDate(date, 'HH', locale);
  }

  override dayViewHour({ date, locale }: DateFormatterParams) {
    return formatDate(date, 'HH', locale);
  }
}

const components = [CalendarComponent];

@NgModule({
  declarations: components,
  exports: [components],
  imports: [
    CommonModule,
    ButtonModule,
    IconModule,
    FormsModule,
    AngularCalendarModule.forRoot(
      {
        provide: DateAdapter,
        useFactory: adapterFactory,
      },
      {
        dateFormatter: {
          provide: CalendarDateFormatter,
          useClass: NumericTimeFormatter,
        },
      },
    ),
  ],
})
export class CalendarModule {}
